/*
 *   Copyright (c) 2026 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import gql from "graphql-tag";

// Per-person ticket cap check for a fete, called before opening the Book
// Now ticket-selection modal on the Events ("Fete Tickets") page.
export const GET_USER_TICKET_COUNTS = gql`
  query GetUserTicketCounts($feteId: String) {
    getUserTicketCounts(feteId: $feteId) {
      gemsUserId
      summary {
        totalPurchased
        totalHeld
        totalTickets
      }
    }
  }
`;
